import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Header, Grid, Form } from 'semantic-ui-react';
import { EssorButton } from 'components';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';

class ShowSubscribedOption extends Component {
  state = {
    value: null,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      !isEmpty(nextProps.retrieved)
      && nextProps.retrieved['hydra:member'][0].value !== prevState.value
      && nextProps.retrieved['hydra:member'][0].name === 'SUBSCRIBED_OPTION'
    ) {
      return {
        value: nextProps.retrieved['hydra:member'][0].value,
      };
    }

    return null;
  }

  render() {
    const { value } = this.state;

    const { loading, selectedOffice, t } = this.props;

    return (
      <div className="section-container">
        <div className="section-general">
          <div className="option-buttons-container clearfix">
            <Header as="h3">{t('officesSubscribedOption')}</Header>
            <EssorButton as={Link} to={`/offices/${selectedOffice.id}/settings/subscribed-option/edit`} type="edit" size="tiny" floated="right">
              {t('buttonEdit')}
            </EssorButton>
          </div>
          <Grid>
            <Grid.Row>
              <Grid.Column width={12}>
                <Form className="margin-top-bot main-form" loading={loading} size="small">
                  <Form.Group inline>
                    <Form.Checkbox
                      label={t('formSellingSuccess')}
                      checked={value ? value.sellingSuccess : false}
                      readOnly
                    />
                  </Form.Group>

                  <Form.Group inline>
                    <Form.Checkbox
                      label={t('formManagementSecret')}
                      checked={value ? value.managementSecret : false}
                      readOnly
                    />
                  </Form.Group>

                  <Form.Group inline>
                    <Form.Checkbox
                      label={t('formLegal')}
                      checked={value ? value.legal : false}
                      readOnly
                    />
                  </Form.Group>

                  <Form.Group inline>
                    <Form.Checkbox
                      label={t('formManagementSecret2')}
                      checked={value ? value.managementSecret2 : false}
                      readOnly
                    />
                  </Form.Group>

                  <Form.Group inline>
                    <Form.Checkbox
                      label={t('formTalents')}
                      checked={value ? value.talents : false}
                      readOnly
                    />
                  </Form.Group>

                  <Form.Group inline>
                    <Form.Checkbox
                      label={t('formWebsitesAndSocial')}
                      checked={value ? value.websitesAndSocial : false}
                      readOnly
                    />
                  </Form.Group>
                  <Form.Group inline>
                    <Form.Field>
                      <label>{t('formRemoteProspecting')}</label>
                      <h5 className="informative-field">
                        {value && (value.remoteProspecting === '' ? '-' : value.remoteProspecting)}
                      </h5>
                    </Form.Field>
                  </Form.Group>
                </Form>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  error: state.officeSettings.show.error,
  loading: state.officeSettings.show.loading,
  retrieved: state.officeSettings.show.retrieved,

  selectedOffice: state.userCompanies.select.selectedOffice,
});

const Main = connect(mapStateToProps)(ShowSubscribedOption);

export default withTranslation()(withRouter(Main));
